import React, { useState, useCallback, useEffect } from 'react'
import './partner.css'
import { Modal, Box, IconButton, Typography } from '@mui/material'
import { useLazyGetGroupOfPartnerQuery } from '../../../app/services/partnerService'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
// import { TeacherAssocation, Corporates, educationInsititue } from '../../../constant/constant'
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import CloseIcon from '@mui/icons-material/Close';
import Spinner from "../../../Component/spinner/spinner"
const Partner = () => {
  const [openModal, setOpenModal] = useState(false);
  const [getAllPartner, setGetAllPartners] = useState([]);
  const [getAll] = useLazyGetGroupOfPartnerQuery()
  const [partnerModal, setPartnerModal] = useState()
  const [partner, setPartner] = useState()
  const [loading, setLoading] = useState(true)

  const handleOpenModal = (data) => {
    setPartner(data)
    setOpenModal(true);
    // setSelectedMember(id);
    setPartnerModal(data)
  };

  const handleClose = () => {
    setOpenModal(false);
    // setTextOpen(false)
  };
  const fetchGetAll = useCallback(async () => {
    setLoading(true)
    try {
      const res = await getAll();
      setGetAllPartners(res?.data?.data);
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)
    }
  }, [getAll]);

  useEffect(() => {
    fetchGetAll();
  }, [fetchGetAll, getAllPartner]);
  function EnhancedTableHead() {
    const headCells = [
      {
        id: "title",
        numeric: false,
        disablePadding: true,
        label: "Title"
      },
      {
        id: "startDate",
        numeric: false,
        disablePadding: true,
        label: "Start Date"
      },
      {
        id: "endDate",
        numeric: false,
        disablePadding: true,
        label: "End Date"
      },
      {
        id: "location",
        numeric: false,
        disablePadding: true,
        label: "Location"
      },
    ];

    return (
      <>
        <TableHead>
          <TableRow className="menus-color">
            {headCells.map((headCell) => (
              <TableCell
                sx={{ textAlign: "center", color: "#ffff", width: headCell.id === "actions" ? headCell.width : "auto" }}
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
              >
                {headCell.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      </>
    );
  }

  return (
    <div className="pt-5">
      <div className="chapter-heading">
        <h2 className="text-center title-font text-light py-3 mt-1">Our Partner (Past & Present)</h2>
      </div>
      <div className='p-md-5 p-3 overallContactPadding'>
        <div className='mt-2 pb-3 '>
          {/* <Container maxWidth={"lg"}> */}
          {loading ? (
            <Spinner />
          ) :
            getAllPartner && getAllPartner.length > 0 ? (
              <>
                {getAllPartner.map((data, i) => (
                  <div>
                    <div key={i} className="category-header-container">
                      <h3 className="category-title title-font text-capitalize">
                        {data?.category}
                      </h3>
                      <span className="category-count title-font">
                        {data?.count}
                      </span>
                    </div>
                    <div className='row d-flex justify-content-center  '>
                      {data?.partners?.map((partner, i) => (
                        <div className='col-md-4 col-sm-6 col-xl-3 p-3' key={i}>
                          <div className='teacher-asso-card' onClick={() => handleOpenModal(partner)}>
                            <div className='partner-logo-container'>
                              <img src={partner?.logo} alt='our-partner' className='our-partner-img-pat' />
                            </div>
                            <div className='p-3 text-center d-flex flex-column justify-content-center flex-grow-1'>
                              <p className='content-font details-partner text-capitalize mb-2'>{partner?.partnerName}</p>
                              <p className='content-font location-partner text-capitalize mb-0'>{partner?.location}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                ))}
                <Modal
                  open={openModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"

                >

                  <Box
                    className="d-flex container justify-content-start flex-column p-0"
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      maxHeight: '85vh',
                      width: '90%',
                      maxWidth: '800px',
                      backgroundColor: 'white',
                      WebkitTapHighlightColor: 'transparent',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                      borderRadius: '8px',
                      outline: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      scrollbarWidth: 'none', // Firefox
                      msOverflowStyle: 'none', // IE 10+
                    }}
                    sx={{
                      '&::-webkit-scrollbar': {
                        display: 'none', // Chrome, Safari
                      },
                    }}
                  >
                    <div className="modal-header-bg d-flex justify-content-between align-items-center">
                      <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.25rem" }}>
                        <span className='text-capitalize'>{partnerModal?.partnerName} {partnerModal?.category ? `(${partnerModal.category})` : ''}</span>
                      </Typography>
                      <IconButton onClick={handleClose} aria-label="Close" sx={{ color: 'white' }}>
                        <CloseIcon />
                      </IconButton>
                    </div>

                    <div className="modal-content-container d-flex flex-column gap-3">
                      <div className='d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 mb-3'>
                        <div>
                          <img src={partnerModal?.logo} alt={partnerModal?.partnerName} />
                        </div>
                        <div>
                          <p className='mt-1 text-capitalize'>{partnerModal?.location}</p>
                          <p><span>{partnerModal?.fromYear}</span >{' '}<span className='fw-normal'>-{' '}{partnerModal?.toYear}</span></p>
                        </div>

                      </div>
                      <div className='row'>
                        <a className='text-center' href={partner?.websiteLink?.startsWith('http') ? partner.websiteLink : `https://${partner?.websiteLink}`} target='_blank' rel="noreferrer">{partner?.websiteLink}</a>
                      </div>
                      <div className='row mt-2'>
                        <p className='text-justify partner-text-justify'>{partnerModal?.description}</p>
                      </div>
                      {partnerModal?.eventsDetails?.length > 0 && (<>

                        <p className="fw-bold mb-2" style={{ color: "#0d4022", fontWeight: "bold" }} >
                          Event List
                        </p>
                        <TableContainer component={Paper} className="rounded-0 mb-3" sx={{ boxShadow: 0 }}>
                          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                            <EnhancedTableHead />
                            <TableBody>
                              {partnerModal?.eventsDetails?.length > 0 ? (
                                partnerModal?.eventsDetails?.map((row, index) => (
                                  <TableRow
                                    hover
                                    key={index}
                                    sx={{
                                      cursor: "pointer",
                                      backgroundColor:
                                        index % 2 === 0 ? "#f0f0f0" : "white",
                                    }}
                                  >
                                    <TableCell align="center">
                                      {row?.title}
                                    </TableCell>
                                    <TableCell align="center">
                                      {new Date(row?.startDate).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row?.endDate ? new Date(row?.endDate).toLocaleDateString() : '-'}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row?.venue ? row?.venue : '-'}
                                    </TableCell>

                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={8} align="center">
                                    Will Be Added Shortly
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>)}

                      {/* <div className="row ms-3">
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th>Title</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Location</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {partnerModal?.eventsDetails?.length > 0 ? (
                                            partnerModal.eventsDetails.map((ed, i) => (
                                              <tr key={i}>
                                                <td>{ed?.title}</td>
                                                <td>{new Date(ed?.startDate).toLocaleDateString()}</td>
                                                <td>{new Date(ed?.endDate).toLocaleDateString()}</td>
                                                <td>{ed?.venue}</td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td colSpan="6" className="text-center">No events found</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div> */}




                    </div>
                  </Box>
                </Modal>
              </>
            ) : (
              <>  <div className='d-flex justify-content-center'>
                <ErrorOutlineIcon style={{ fontSize: 50, color: 'red' }} />
                <h3 className="text-danger">Will Be Added Shortly</h3>
              </div></>
            )}
          <div className='d-flex'>

          </div>
          {/* </Container> */}
        </div>
      </div>
    </div>
  )
}

export default Partner